module.exports = __webpack_public_path__ + "static/media/residencial.6c74c588.svg";